import { render, staticRenderFns } from "./CustomerObs.vue?vue&type=template&id=bb31d338&scoped=true&"
import script from "./CustomerObs.vue?vue&type=script&lang=js&"
export * from "./CustomerObs.vue?vue&type=script&lang=js&"
import style0 from "./CustomerObs.vue?vue&type=style&index=0&id=bb31d338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb31d338",
  null
  
)

export default component.exports